import { SidebarAccountInfo } from "@/components/layout/components/sidebar/sidebar-account-info";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { MenuItem } from "react-aria-components";

export const SidebarDropdownAccountInfo = observer(function SidebarDropdownAccountInfo() {
  const { store } = useAppStore();
  const { profilePhotoUrl, profileDisplayName, profileEmailAddress } = store.account.myAccount;

  return (
    <SidebarAccountInfoWrapper isDisabled>
      <SidebarAccountInfo
        profilePhotoUrl={profilePhotoUrl}
        profileDisplayName={profileDisplayName}
        profileEmailAddress={profileEmailAddress}
        plan={store.subscriptions.personalPlanId}
      />
    </SidebarAccountInfoWrapper>
  );
});

const SidebarAccountInfoWrapper = styled(MenuItem)`
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
`;
